import styled from 'styled-components';
import { layout } from 'src/components/base';

export const ProductInfo = styled.p`
  max-width: 500px;

  color: ${p => p.theme.text.secondary};
  a {
    color: ${p => p.theme.text.secondary};
    text-decoration: underline;
  }
`;
export const SubSection = styled.div`
  margin-bottom: ${layout.measurements.spacing200};
`;
